/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cl_Dialog_TitleInputs */

const en_cl_dialog_title = /** @type {(inputs: Cl_Dialog_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Content language of ${i?.name}`)
};

const de_cl_dialog_title = /** @type {(inputs: Cl_Dialog_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inhaltssprache von ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Content language of {name}" |
*
* @param {Cl_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_dialog_title = /** @type {((inputs: Cl_Dialog_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Dialog_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_dialog_title(inputs)
	return en_cl_dialog_title(inputs)
});